module.exports = VueApexCharts;